<template>
	<div>
		<div class="content">
			<!-- 隐患数量走势图 -->
			<div id="hiddenTroubleNumberMoves">
				<div class="title">
					<div class="leftSquare"></div>
					<div class="text">隐患数量走势图</div>
				</div>

				<div id="Box">
					<div id="lineChart"></div>
				</div>
			</div>
			<!-- 隐患数量走势图 -->
		</div>
	</div>
</template>
<script>
	import {
		apiurl,
		imgurl
	} from '../../common/js/baseApi.js'
	import axios from 'axios'
	export default {
		components: {},
		data() {
			return {
				pId: '', // 用户id
				nowClientWidth: 1920 // 默认屏幕宽度
			}
		},
		computed: {},
		watch: {},
		methods: {
			getTotalByTroubleType() {
				axios.get(apiurl + '/index/totalByTroubleType', {
						params: {
							pId: this.pId
						}
					})
					.then(data => {
						if (data.data.status !== 1) {
							return
						}
						let res = data.data.data

						let myChart = this.$echarts.init(document.getElementById('lineChart'))
						let option = {
							tooltip: {
								trigger: 'axis',
								textStyle:{
									fontSize:this.nowSize(14),
								}
							},
							legend: {
								data: [{
									name: '重大隐患',
									icon: 'roundRect'
								}, {
									name: '一般隐患',
									icon: 'roundRect'
								}],
								top: this.nowSize(18),
								right: this.nowSize(24),
								itemGap: this.nowSize(32),
								itemWidth:this.nowSize(20),
								itemHeight:this.nowSize(8),
								textStyle:{
									color:"#FFFFFF",
									fontSize:this.nowSize(14)
								}
							},
							grid: {
								top: this.nowSize(50),
								left: this.nowSize(40),
								right: this.nowSize(18),
								bottom: this.nowSize(40)
							},
							xAxis: {
								type: 'category',
								boundaryGap: false,
								data: res.dateTime,
								axisLine: {
									lineStyle: {
										color: "#fff",
										width: this.nowSize(1),
										opacity: 0.3
									}
								},
								axisLabel: {
									margin: this.nowSize(8),
									color: "#fff",
									fontSize: this.nowSize(14)
								}
							},
							yAxis: {
								type: 'value',
								splitLine: { //分割线
									show: true, //控制分割线是否显示
									lineStyle: { //分割线的样式
										type: 'dashed',
										color: "#fff",
										width: this.nowSize(1),
										opacity: 0.3
									}
								},
								axisLine: {
									show: true,
									lineStyle: {
										color: "#fff",
										width: this.nowSize(1),
										opacity: 0.3
									}
								},
								axisLabel: {
									margin: this.nowSize(8),
									color: "#fff",
									fontSize: this.nowSize(14)
								}
							},
							series: [{
									name: '重大隐患',
									type: 'line',
									data: res.type1,
									itemStyle: {
										color: "#F87A1C"
									},
									lineStyle: {
										width: this.nowSize(2),
									}
								},
								{
									name: '一般隐患',
									type: 'line',
									data: res.type2,
									itemStyle: {
										color: "#02A6F4"
									},
									lineStyle: {
										width: this.nowSize(2),
									}
								}
							],
						};
						myChart.setOption(option);
					})
					.catch(err => {

					})
			},
			nowSize(val, initWidth = 1920) {
				return val * (this.nowClientWidth / initWidth);
			}
		},
		created() {},
		mounted() {
			this.nowClientWidth = document.documentElement.clientWidth;
			var url = window.location.search
			var theRequest = new Object()
			if (url.indexOf('?') != -1) {
				var str = url.split('?')[1]
				var strs = str.split('&')
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split('=')[0]] = (strs[i].split('=')[1])
				}
			}
			this.pId = theRequest.pId
			this.getTotalByTroubleType()
		},
		beforeCreate() {},
		beforeMount() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		activated() {},
	}
</script>
<style lang='scss' scoped>
	@mixin titleStyle {
		.title {
			position: absolute;
			left: 0;
			top: -0.625rem;
			display: flex;
			align-items: center;

			.leftSquare {
				width: 0.25rem;
				height: 1.25rem;
				background-color: #00EAFF;
				margin-right: 0.875rem;
			}

			.text {
				font-size: 1.25rem;
				color: #00EAFF;
			}
		}
	}

	.content {
		width: 27.1875rem;
		height: 16.4375rem;
		background: url(../../common/img/right/bg1.png) 0 0 no-repeat;
		background-size: 100% 100%;

		/* 隐患数量走势图 */
		#hiddenTroubleNumberMoves {
			position: relative;
			width: 100%;
			height: 100%;

			@include titleStyle;

			#Box {
				display: flex;
				align-items: center;
				justify-content: center;
				box-sizing: border-box;
				margin-top: 0.625rem;
				width: 100%;
				height: 100%;

				#lineChart {
					padding-top: 0.625rem;
					width: 100%;
					height: 100%;
					box-sizing: border-box;
				}
			}
		}

		/* 隐患数量走势图 */
	}
</style>



// WEBPACK FOOTER //
// src/components/rightCenter/index.vue